import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://rariumgroup.it";
const DEFAULT_IMG = "https://images.pexels.com/photos/17483087/pexels-photo-17483087.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Seo({
  title = "Rarium — Aste Curate Online per Collezionisti",
  description = "Casa d'aste online per collezionisti esigenti. Orologi, arte, gioielli, auto classiche, vini, monete e libri rari — ogni lotto autenticato dai nostri esperti.",
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd = null,
  noindex = false,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title.includes("Rarium") ? title : `${title} | Rarium`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Rarium" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
